// extracted by mini-css-extract-plugin
export default {"base":"vp_Ptn9J","item":"vp_g_Z44","details":"vp_rE_We","title":"vp_KX2n3","description":"vp_JaLmq","gauges":"vp_eNA_j"};